import { render } from "./ResourcePlaceholder.vue?vue&type=template&id=023c9b96&scoped=true"
import script from "./ResourcePlaceholder.vue?vue&type=script&lang=js"
export * from "./ResourcePlaceholder.vue?vue&type=script&lang=js"

import "./ResourcePlaceholder.vue?vue&type=style&index=0&id=023c9b96&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Raska\\Desktop\\raska\\projekat\\astra\\astra-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-023c9b96"]])

export default __exports__